import type { ReactNode } from "react";
import { Marker, Popup } from "react-leaflet";
import { divIcon } from "@/components/maps/leafletIcons";

/**
 * A single pin on <Map>. Pass `color` for a colored dot marker (e.g. driver
 * online = teal, ride issue = red) instead of the default Leaflet pin.
 */
export function MapMarker({
  position,
  color,
  label,
  children,
}: {
  position: [number, number];
  color?: string;
  label?: string;
  children?: ReactNode;
}) {
  const icon = color
    ? divIcon(
        `<div style="width:14px;height:14px;border-radius:9999px;background:${color};border:2px solid white;box-shadow:0 0 0 1px rgba(0,0,0,0.15)"></div>`,
        [14, 14],
      )
    : undefined;

  return (
    <Marker position={position} icon={icon}>
      {(label || children) && <Popup>{children ?? label}</Popup>}
    </Marker>
  );
}
